import * as React from 'react';
import { Searches as IconSearches } from '../../Icons/';
import { IHeaderV1Schema } from '../../../repositories/header/entities/response/HeaderV1Schema';
import { Icon } from '../Icon';

export interface ISearchesNotificatorProps {
  headerData: IHeaderV1Schema;
  newHeaderEnabled?: boolean;
}

export class SearchesNotificator extends React.Component<ISearchesNotificatorProps> {
  public render() {
    const { headerData, newHeaderEnabled } = this.props;

    const count = Number(headerData.storedFiltersCount || 0);
    const savedSearchLinkUrl = headerData.lkLinks?.savedSearch;

    return (
      <Icon
        onClick={this.handleClick}
        iconView={<IconSearches />}
        link={savedSearchLinkUrl}
        notifications={newHeaderEnabled ? 0 : count}
        title="Сохранённые поиски"
      />
    );
  }

  private handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (window._headerTrackingEvent) {
      window._headerTrackingEvent('saved-search');
    }
  };
}
